import SuccessStoryList from "../components/SuccessStoryList";

const ListSuccessStoryPage = () => {
  return (
    <SuccessStoryList />
  );
};

export default ListSuccessStoryPage;
